import { makeActionCreator } from '../../../utilities'
import { NarrativeConstants } from './narrative.constants'

export const setNarrativeText = makeActionCreator(NarrativeConstants.SET_NARRATIVE_TEXT, 'narrativeText')
export const setNarrativeTextPNNV = makeActionCreator(NarrativeConstants.SET_NARRATIVE_TEXT_PNNV, 'narrativeTextPNNV')
export const saveNarrative = makeActionCreator(NarrativeConstants.SAVE_NARRATIVE)
export const setNarrativeState = makeActionCreator(NarrativeConstants.SET_NARRATIVE_STATE, 'narrative')
export const setSaveNarrativeResponse = makeActionCreator(NarrativeConstants.SET_RESPONSE, 'response')
export const resetNarrativeState = makeActionCreator(NarrativeConstants.RESET_STATE)
export const setHpi = makeActionCreator(NarrativeConstants.SET_HPI, 'hpi')
